import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

export function MobileHeader({ onMenuClick }: MobileHeaderProps) {
  return (
    <header
      className="lg:hidden fixed top-0 left-0 right-0 h-16 z-40 px-4 flex items-center justify-between"
      style={{
        background: 'var(--bt-card)',
        backdropFilter: 'blur(var(--bt-blur)) saturate(160%)',
        WebkitBackdropFilter: 'blur(var(--bt-blur)) saturate(160%)',
        borderBottom: '1px solid var(--bt-glass-stroke)',
      }}
    >
      <Link to="/dashboard" className="flex items-center gap-2.5">
        <div
          style={{
            width: 28,
            height: 28,
            background: 'var(--bt-ink)',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span
            style={{
              fontFamily: "'Fraunces', serif",
              fontStyle: 'italic',
              color: 'var(--bt-ink-2)',
              fontSize: 14,
              fontWeight: 500,
              lineHeight: 1,
            }}
          >
            m
          </span>
        </div>
        <span
          style={{
            fontFamily: "'Fraunces', serif",
            fontStyle: 'italic',
            fontSize: 18,
            fontWeight: 500,
            color: 'var(--bt-ink)',
            letterSpacing: '-0.02em',
          }}
        >
          mamal
        </span>
      </Link>
      <button
        onClick={onMenuClick}
        className="p-2 rounded-xl transition-colors"
        style={{ color: 'var(--bt-ink)' }}
        aria-label="Menü öffnen"
      >
        <Menu className="w-5 h-5" />
      </button>
    </header>
  );
}
